import React from 'react';
import { Package, AlertCircle, ArrowLeftRight, CheckCircle } from 'lucide-react';

export default function StatsCards({ counts }) {
  const stats = [
    {
      label: 'Total',
      value: counts.all,
      icon: Package,
      iconColor: 'text-locate2-primary',
      bgColor: 'bg-locate2-bg-icon',
    },
    {
      label: 'Pending',
      value: counts.pending,
      icon: AlertCircle,
      iconColor: 'text-locate2-medium-gray',
      bgColor: 'bg-status-pending-bg',
    },
    {
      label: 'Returns/Exchange',
      value: (counts.exchange || 0) + (counts.returned || 0),
      icon: ArrowLeftRight,
      iconColor: 'text-status-warning',
      bgColor: 'bg-status-warning-bg',
    },
    {
      label: 'Actioned',
      value: counts.actioned,
      icon: CheckCircle,
      iconColor: 'text-status-success',
      bgColor: 'bg-status-success-bg',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.label}
            className="bg-white rounded-lg border border-locate2-border p-4"
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-10 h-10 rounded-full ${stat.bgColor} flex items-center justify-center`}
              >
                <Icon size={20} className={stat.iconColor} />
              </div>
              <div>
                <p className="text-2xl font-bold text-locate2-dark-blue">
                  {stat.value}
                </p>
                <p className="text-locate2-light-gray text-sm">{stat.label}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
